class EjanseStreetStrip extends HTMLElement {
  #abort = new AbortController();
  #observer;

  connectedCallback() {
    const signal = this.#abort.signal;
    this.list = this.querySelector('[data-ejanse-strip-list]');
    this.prev = this.querySelector('[data-ejanse-strip-prev]');
    this.next = this.querySelector('[data-ejanse-strip-next]');
    this.#deferImages();
    if (!this.list || !this.prev || !this.next) return;

    this.prev.addEventListener('click', () => this.#step(-1), { signal });
    this.next.addEventListener('click', () => this.#step(1), { signal });
    this.list.addEventListener('scroll', () => this.#update(), { signal, passive: true });
    window.addEventListener('resize', () => this.#update(), { signal, passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.#abort.abort();
    this.#observer?.disconnect();
  }

  /** Photos start downloading when the visitor scrolls to within 300px of the strip, so they never load on the first screen. */
  #deferImages() {
    const start = () => {
      this.#observer?.disconnect();
      for (const img of this.querySelectorAll('img[data-ejanse-src]')) {
        if (img.dataset.ejanseSrcset) img.srcset = img.dataset.ejanseSrcset;
        img.src = img.dataset.ejanseSrc;
        img.removeAttribute('data-ejanse-src');
        img.removeAttribute('data-ejanse-srcset');
      }
    };
    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) start();
      },
      { rootMargin: '300px 0px' }
    );
    this.#observer.observe(this);
  }

  #step(direction) {
    const item = this.list.firstElementChild;
    if (!item) return;
    const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.list.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  #update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.list;
    this.prev.disabled = scrollLeft <= 1;
    this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
  }
}

if (!customElements.get('ejanse-street-strip')) customElements.define('ejanse-street-strip', EjanseStreetStrip);
